<template>
  <div class="py-4 px-2">
    <div class="flex">
      <div class="w-full relative">
        <input @focus="$emit('search')" @input="$emit('incrementSearch', $event.target.value)" debounce="500" class="w-full pr-3 py-2 pl-8 border border-section_border rounded-lg shadow-sm" type="text" :placeholder="$t('map_search_placeholder')" />
        <button @click="$emit('closeSearchPanel')" class="absolute left-0 top-0 h-full flex items-center ml-2 focus:outline-none">
          <svg v-if="onSearch" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" class="text-body text-opacity-75"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <svg
            v-else
            class="h-4 w-4 fill-current text-supplement"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 56.966 56.966"
            width="512"
            height="512">
            <path d="M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"/>
          </svg>
        </button>
      </div>
      <a @click="$emit('openFilterPanel')" v-bind:class="{ 'mr-16': this.$store.getters['user/isFilterOn']({id: 'mobaku'}) }" class="p-2 bg-white border border-pale_green rounded-lg shadow-sm ml-2">
        <svg
          class="m-1 h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 1000">
          <path d="M10 780h595v70H10v-70zM815 780h175v70H815v-70zM780 918.9c0 39.3-31.3 71.1-70 71.1s-70-31.8-70-71.1V711.1c0-39.3 31.3-71.1 70-71.1s70 31.8 70 71.1v207.8zM10 465h175v70H10v-70zM395 465h595v70H395v-70zM360 603.9c0 39.3-31.3 71.1-70 71.1s-70-31.8-70-71.1V396.1c0-39.3 31.3-71.1 70-71.1s70 31.8 70 71.1v207.8zM10 150h595v70H10v-70zM815 150h175v70H815v-70zM780 288.9c0 39.3-31.3 71.1-70 71.1s-70-31.8-70-71.1V81.1c0-39.3 31.3-71.1 70-71.1s70 31.8 70 71.1v207.8z"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onSearch: {
      type: Boolean,
      required: true
    }
  }
}
</script>
